export default __webpack_public_path__ + "590c8e926fe626e4ec47502a149dff4f.ttf";